<template>
    <div class="ReInputSyntaxHighlight">
            <CodeEditor 
            v-model="bufferValue"
           
            :line-nums="true"
            :languages="[['php', 'PHP'], ['json', 'JSON'], ['js', 'JS']]"
            :lang-list-display="true"
            selector_height="40px"
            language_selector 
            :wrap_code="true"
            :theme="theme"
            :autofocus="true"
            :tab-spaces="4"
            height="100%"
            
            width="auto"
            z_index="0"
            @lang="getLanguage"
            @textarea="focus"
            
            ></CodeEditor>
            <!-- <pre><code >if($BP_ARR['name'] != ''){
    $elements[]=array(
        'elementID'=>'',
        'element_model'=>$BP_ARR['name'],
        'elementType'=>'label',
        'placeholder'=>'Услуга',
    );
}</code></pre> -->
       
    </div>
</template>
<script>
import { Button } from 'element-ui';
import hljs from 'highlight.js';
import CodeEditor from "simple-code-editor";


export default {
    name: 'ReInputSyntaxHighlight',
    components: {
        [Button.name]: Button,
        CodeEditor,
    },
    props: {
        value: String,
        findId: {
			type: String,
			default: '',
		},
		required:{
			type: Boolean,
			default: false
		},
        // language:{
        //     type: String,
		// 	default: 'php'
        // }
    },
    data () {
        return {
            bufferValue:'',
            // maslanguages:['php','javascript','json','python','bash','sql', 'java', 'yaml', 'html', 'plaintext'], 
            theme:'dark',
        }
    },
    watch:{
        value(val){
            this.bufferValue = val;
            // this.bufferValue = this.$GVO.unlinkObject(val);
        },
        bufferValue(val){
            this.bufferValue = val;
            this.$emit("input", this.bufferValue);
        },
    },
    methods: {
        highlight(){
           
            // console.log('hljs',hljs);
            // const php = hljs.getLanguage('php'); // загузилось, т.е. язык есть
            
            // hljs.highlight(this.text, {'php'}); 

            // this.highlightAll();
            // setTimeout(this.highlightAll(), 0);
            // hljs.highlightAll();
            // const highlightedCode = hljs.highlight(
            // this.text,
            // { language: 'php' }
            // ).value;
            // console.log('highlightedCode',highlightedCode);
        },
        highlightAll(){
            document.querySelectorAll("code").forEach((e) => {
                // console.log('highlightAll',e.dataset);
                if (!e.dataset.highlighted) {
                hljs.highlightElement(e);
                } 

                // delete e.dataset.highlighted;
                // hljs.highlightElement(e);
            });
        },
        getLanguage(lang) {
            // console.log("The current language is: " + lang);
        },
        focus(node) {
            node.focus();
        },
        getThemeColor(){
            if(this.$GVO.my_profile.theme == 1){this.theme='dark';}else{this.theme='light';}
        }
    },
    mounted() {
        this.getThemeColor();
        this.bufferValue = this.value;
        // this.highlight();
        
    }
}
</script>
<style scoped>
.message-container {display: inline-flex; width: 100%;}
.ReInputSyntaxHighlight >>> .mark {background-color: transparent!important;}
.ReInputSyntaxHighlight >>> .code_editor .header {margin-bottom:0px!important;}
.ReInputSyntaxHighlight >>>  .code_area {resize: vertical!important;}
</style>